(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300),
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["production-chain"] && !Shopify.designMode) return;
  try {
    
  class ProductionChainSection {
    constructor(section) {
      this.section = section;
      this.scroller = section.querySelector('[data-production-chain-scroller]');
      this.cards = Array.from(section.querySelectorAll('[data-production-chain-card]'));
      this.dots = Array.from(section.querySelectorAll('[data-production-chain-dot]'));
      this.progress = Array.from(section.querySelectorAll('[data-production-chain-progress]'));

      if (!this.scroller || !this.cards.length) return;

      this.scroller.addEventListener('scroll', () => this.updateActive(), { passive: true });

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', (event) => {
          event.preventDefault();
          const card = this.cards[index];
          if (!card) return;
          card.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        });
      });

      this.updateActive();
    }

    updateActive() {
      const scrollerLeft = this.scroller.getBoundingClientRect().left;
      let activeIndex = 0;
      let closestDistance = Infinity;

      this.cards.forEach((card, index) => {
        const distance = Math.abs(card.getBoundingClientRect().left - scrollerLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          activeIndex = index;
        }
      });

      this.dots.forEach((dot, index) => dot.classList.toggle('is-active', index === activeIndex));
      this.progress.forEach((bar, index) => bar.classList.toggle('is-active', index === activeIndex));
    }
  }

  document.querySelectorAll('.production-chain-outer').forEach((section) => {
    new ProductionChainSection(section);
  });

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.production-chain-outer');
    if (section) new ProductionChainSection(section);
  });

  } catch(e) { console.error(e); }
})();
})();
